/* Model */
class RouteDriverAssignmentModel extends App.Models.AssignUnassignToRoute {
    modelUrl = 'RouteDriverAssignment';
    urlAssignUnassign = "RouteDriver";
}

App.Models.RouteDriverAssignment = RouteDriverAssignmentModel;

/* Collection */
class RouteDriverAssignmentCollection extends App.Collections.BaseCollection {
    url = 'RouteDriverAssignment';
    model = App.Models.RouteDriverAssignment;
}

App.Collections.RouteDriverAssignments = RouteDriverAssignmentCollection;

/* Router */
class RouteDriverAssignmentRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'RouteDriverAssignment';
        const model = App.Models.RouteDriverAssignment;
        const collectionClass = App.Collections.RouteDriverAssignments;

        super(entityName, model, collectionClass);
    }
}

App.Routers.RouteDriverAssignment = RouteDriverAssignmentRouter;
